import React from 'react';
import {Button, Card, Form, message, Modal, Icon} from 'antd';
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import CkInfoItem from "../../components/CkInfoItem";
import CkUploads from "../../components/CkUploads";
import {patchEventPosters, updateEventPosters} from "../../services/evt";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewPosterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,
            editSort:false,
            posterVals:props.evt.posters.map((poster, index) => {
                return {
                    id: poster.id,
                    uid: poster.id,
                    status: 'done',
                    url: poster.url,
                    thumbUrl: poster.url,
                }
            })
        }
    }
    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    resetFormFields = () => {
        this.props.form.resetFields();
        this.props.form.setFieldsValue({__self__: []});
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.onSubmit(values);
            } else {
                console.log('error', error, values);
            }
        });
    }

    onSubmit = (values) =>{
        this.changeFormLoading(true);
        const that = this;
        values.__self__.forEach((obj,index)=>{
            obj.seq=index;
        });
        patchEventPosters(Object.assign({eventId: this.props.evt.header.id}, values)).then(res => {
            if (res.code == 200) {
                message.info("更新成功!");
                that.props.editableChange(this.props.editableStatePropName, false, true)
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
            that.changeFormLoading(false)
        })
    }

    changeFormLoading = (loading) => {
        if(this.mounted){
            this.setState({
                formLoading: loading
            })
        }
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    //移动
    moveItem = (values,index,type) =>{
        let from =index;
        let to =type == 'up' ? index-1 : index+1;
        values.splice(to, 0, values.splice(from, 1)[0]);
        this.setState({
            posterVals:values
        })
    }

    render() {
        const evt = this.props.evt;
        const {posterVals,editSort} = this.state;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;


        const formItemLayout = {
            labelCol: {
                xs: {span: 3},
                sm: {span: 3},
            },
            wrapperCol: {
                xs: {span: 20},
                sm: {span: 20},
            },
        };


        // const posterVals = evt.posters.map((poster, index) => {
        //     return {
        //         id: poster.id,
        //         uid: poster.id,
        //         status: 'done',
        //         url: poster.url,
        //         thumbUrl: poster.url,
        //     }
        // })

        return (
            <div>
                <Card bodyStyle={{padding: "16px"}}>
                    <div className="evt-create-editable-tools">
                        <Button size="small"  onClick={(e) => {
                            if(editSort){
                                this.onSubmit({__self__:posterVals})
                            }else {
                                this.setState({editSort:true})
                            }

                        }}>{editSort ? '保存' : '排序'}</Button>
                        <Button type="primary" size="small" ghost onClick={(e) => {
                            this.props.editableChange(this.props.editableStatePropName, true)
                        }}>编辑</Button>
                    </div>
                    <CkInfoItem
                        label={"活动详情图片" + (evt.posters && evt.posters.length > 0 ? `（${evt.posters.length}）` : '')}
                    >
                        <ul className="poster-comp">
                            {posterVals.map((poster, index) => {
                                return (
                                    <li key={`poster${index}`}>
                                        <img src={poster.thumbUrl}/>
                                        {editSort &&
                                        <div className='poster-move'>
                                            {index > 0 && <a onClick={()=>this.moveItem(posterVals,index,'up')}>左移</a>}
                                            {index != (posterVals.length-1) && <a onClick={()=>this.moveItem(posterVals,index,'down')}>右移</a>}
                                        </div>}
                                    </li>
                                )
                            })}
                        </ul>
                    </CkInfoItem>
                </Card>

                {
                    this.props.editable ?   <Modal
                        visible={this.props.editable}
                        title={<span>编辑活动详情图片（图片在「活动详情文字」后展示）<Icon style={{cursor:'pointer'}} onClick={() => window.open('https://www.kancloud.cn/seven_qdj/qdj_detail01/779711')} type="question-circle-o"/></span>}
                        width="650px"
                        afterClose={() => this.resetFormFields()}
                        maskClosable={false}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" onClick={this.handleCancel}>
                                放弃
                            </Button>,
                            <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                                保存
                            </Button>,
                        ]}
                    >
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                    活动图片
                                </span>
                            )}
                            extra="支持分页：宽600x高1300的分页图；或不分页长图 ：宽600*高最大3000，图片大小不能超过4MB."
                        >

                            {getFieldDecorator('__self__', {
                                initialValue:posterVals,
                                getValueFromEvent: (files) => {
                                    console.log("files", files)
                                    return files.map((file) => {
                                        return {
                                            id: file.raw.id,
                                            url: file.url
                                        }
                                    });
                                }
                            })(
                                <CkUploads/>
                            )}
                        </Form.Item>

                    </Modal>: null
                }

            </div>
        )
    }
}


EvtViewPosterForm.contextTypes = {}

EvtViewPosterForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "guestEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewPosterForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewPosterForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewPosterForm.jsx